import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EwayBillDialogModel } from './model';
import { SupplyService } from 'src/app/core/services/api/supply.service';
import { PopupService } from 'src/app/core/services/popup/popup.service';

@Component({
  selector: 'eway-bill',
  templateUrl: './eway-bill.component.html',
  styleUrls: ['./eway-bill.component.scss']
})
export class EwayBillComponent implements OnInit {

  inputData={
    transportId:null,
    vehicleType:null,
    vehicleNumber:null,
    transporterName:null
  }
  constructor(
    public dialogRef: MatDialogRef<EwayBillComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EwayBillDialogModel,
    private supplyService: SupplyService,
    private popupService: PopupService
  ) { }

  ngOnInit(): void {
    console.log(this.data)
  }

  closeIt() {
    this.dialogRef.close(null);
  }

  submit() {
    if(!this.inputData.transportId || !this.inputData.transporterName || !this.inputData.vehicleNumber || !this.inputData.vehicleType){
      this.popupService.openError("Please fill all the required details")
    }else{
      this.dialogRef.close(this.inputData)
    }
  }

}
